<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <em class="add_tx" style="float: right; height: 22px; cursor: pointer" v-if="blnBtnHerramientas" @click="mostrarSubirHerramientaModal()"></em>
    <span
        class="btn btn-file mr-2 marginbotones paddingbotones2"
        v-b-popover.hover.topleft="'Subir Archivo'" v-if="!blnBtnHerramientas"
    >
      <em v-if="!loaderArchivo" class="add_tx" style="float: right; height: 22px; cursor: pointer" @click="showModalSubirHerramientaOrtodontica = true"></em>
      </span>
    <b-modal v-model="showModalSubirHerramienta" centered no-close-on-backdrop size="md"
             no-close-on-esc :hide-footer="true">
      <template #modal-header="{ ok, close }">
        <div class="seccionTitle mLeft h5">
          <em class=" nuevo_cupon_svg" style=" height: 40px"></em>
          <div class="headerTxt mLeft">Subir Herramienta</div>
        </div>
      </template>
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form-group
                id="idMotivo"
                label="Motivo:"
                label-for="input-1"
            >
              <b-form-select class="mb-3 redondeo" @change="obtenerArchivoExpedientePorFlujo($event)">
                <b-form-select-option
                    v-for="flujo in listaFlujoExpedinteDigital"
                    :key="flujo.idFlujoExpedienteDigital"
                    :value="flujo"
                >{{ flujo.flujoExpedienteDigial }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
                id="idTipoHerramienta"
                label="Tipo Herramientas:"
                label-for="input-2"
            >
              <b-form-select class="mb-3 redondeo" @change="obtieneExtensionesArchivo($event)">
                <b-form-select-option
                    v-for="(herramientas, index) in listaArchivoExpedinteDigital"
                    :key="index"
                    :value="herramientas"
                >{{ herramientas.nombreHerramienta }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="tipoHerramienta !== null && listaArchivoAntesGuardar.length == 0">
          <b-col class="mt-2 text-center">
            <label for="idSubirArchivoInp"
                   class="btn btn-light icono-cargar" style="border-radius: 20px;">
                    <span class="colorWhite">
                              <em class="mas_azul_svg  mr-1 mt-1" style="height: 1em"></em>
                    </span>
            </label>
            <br>
            <span style="font-size: small; font-weight:bold">
                               Cargar Archivos
                               </span>
            <b-form-file id="idSubirArchivoInp" type="file" multiple="multiple" v-model="archivoCarga"
                         style="display:none" ref="file-input-1"
                         @change="changeArchivoHerramienta($event)"/>
          </b-col>
        </b-row>
        <b-row v-if="tipoHerramienta !== null && listaArchivoAntesGuardar.length > 0">
          <b-col class="mt-2">
               <span style="font-size: small; font-weight:bold">
                               Archivos Seleccionado
                               </span>
            <hr>
          </b-col>
          <b-col class="mt-2 text-right col-3" v-if="!loaderArchivo">
            <label for="subirArchivoInput"
                   class="btn btn-light icono-cargar" style="border-radius: 20px;">
                    <span class="colorWhite">
                              <em class="mas_azul_svg  mr-1 mt-1" style="height: 1em"></em>
                    </span>
            </label>
            <br>
            <b-form-file id="subirArchivoInput" type="file" multiple="multiple" v-model="archivoCarga"
                         style="display:none" ref="file-input"
                         @change="changeArchivoHerramienta($event)"/>
          </b-col>
          <hr>
        </b-row>
        <b-row class="text-center" v-if="listaArchivoAntesGuardar.length > 0">
          <b-col>
            <b-row v-for="(item, index) of listaArchivoAntesGuardar" :key="index">
              <b-col
                  style="font-size: small; text-align: center; align-content: center;"
                  class="col-12 col-sm-12 col-md-6"
              >
                {{item.nombreArchivo}}
              </b-col>
              <b-col>
                <span v-if="item.estusCarga && !loaderArchivo"
                      style="color: green; font-size: small; text-align: center"
                      class="col-12 col-sm-12 col-md-6"
                >
                   "Listo para cargarse"
                </span>
                <span v-else-if="!item.estusCarga && !loaderArchivo" style="color: red; font-size: small">
                  "Error: formato no aceptado"
                </span>
                <span v-if="item.estusCarga && loaderArchivo"
                      style="color: green; font-size: small; text-align: center"
                      class="col-12 col-sm-12 col-md-6"
                >
                  <b-progress :max="100" height="1.5rem">
                    <b-progress-bar
                        :value="item.progreso"
                        :label="`Cargando....${item.progreso}%`"
                        variant="success"
                        striped
                        animated
                    ></b-progress-bar>
                  </b-progress>
                </span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <div class="modal-footer" style="    justify-content: center !important;">
        <b-button pill
                  v-if="listaArchivosGuardar.length > 0"
                  style="background-color: #0169aa; border-color: #0169aa;"
                  class="mr-3"
                  variant="primary"
                  :disabled="loaderArchivo"
                  @click="guardarHerramienta()"
        ><span v-if="!loaderArchivo">Cargar</span>
          <span v-if="loaderArchivo">Cargando...<b-spinner small></b-spinner></span>
        </b-button>
        <b-button
            pill
            style="background-color: #595959; border-color: #595959;"
            @click="cerrarModalHerramienta()"
        >Cerrar
        </b-button>
      </div>
    </b-modal>

    <b-modal v-model="showModalSubirHerramientaOrtodontica" centered no-close-on-backdrop size="md" no-close-on-esc :hide-footer="true">
      <template #modal-header="{ ok, close }">
        <div class="seccionTitle mLeft h5">
          <em class=" nuevo_cupon_svg" style=" height: 40px"></em>
          <div class="headerTxt mLeft">Subir Herramienta</div>
        </div>
      </template>
      <b-container fluid>
        <b-row  v-if="listaArchivoAntesGuardar.length === 0">
          <b-col class="mt-2 text-center">
            <label for="subirArchivoInput"
                   class="btn btn-light icono-cargar" style="border-radius: 20px;">
                    <span class="colorWhite">
                              <em class="mas_azul_svg  mr-1 mt-1" style="height: 1em"></em>
                    </span>
            </label>
            <br>
            <span  style="font-size: small; font-weight:bold">
                               Cargar Archivos
                               </span>
            <b-form-file id="subirArchivoInput" type="file" multiple="multiple" v-model="archivoCarga"
                         style="display:none" ref="file-input"
                         @change="change($event)"/>
          </b-col>
        </b-row>
        <b-row class="text-center" v-if="listaArchivoAntesGuardar.length > 0">
          <b-col>
            <b-row v-for="(item, index) of listaArchivoAntesGuardar" :key="index">
              <b-col
                  style="font-size: small; text-align: center; align-content: center;"
                  class="col-12 col-sm-12 col-md-6"
              >
                {{item.nombreArchivo}}
              </b-col>
              <b-col>
                <span v-if="item.estusCarga && !loaderArchivo"
                      style="color: green; font-size: small; text-align: center"
                      class="col-12 col-sm-12 col-md-6"
                >
                   "Listo para cargarse"
                </span>
                <span v-else-if="!item.estusCarga && !loaderArchivo" style="color: red; font-size: small">
                  "Error: formato no aceptado"
                </span>
                <span v-if="item.estusCarga && loaderArchivo"
                      style="color: green; font-size: small; text-align: center"
                      class="col-12 col-sm-12 col-md-6"
                >
                  <b-progress :max="100" height="1.5rem">
                    <b-progress-bar
                        :value="item.progreso"
                        :label="`Cargando....${item.progreso}%`"
                        variant="success"
                        striped
                        animated
                    ></b-progress-bar>
                  </b-progress>
                </span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <div class="modal-footer d-flex justify-content-center">
        <b-button pill
                  v-if="listaArchivosGuardar.length > 0"
                  style="background-color: #0169aa; border-color: #0169aa;"
                  class="mr-3"
                  variant="primary"
                  :disabled="loaderArchivo"
                  @click="guardarHerramientaOrtodontica()"
        ><span v-if="!loaderArchivo">Cargar</span>
          <span v-if="loaderArchivo">Cargando...<b-spinner small></b-spinner></span>
        </b-button>
        <b-button
            pill
            style="background-color: #595959; border-color: #595959;"
            @click="cerrarModalHerramienta"
        >Salir
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {DeleteObjectsCommand, S3Client} from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";
import moment from "moment/moment";
import {AwsService} from "../../../apiServices/aws/AwsService";

export default {
  name: "SubirHerramientaModal",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    awsServicio: new AwsService(),
    showModalSubirHerramienta: false,
    showModalSubirHerramientaOrtodontica : false,
    listaFlujoExpedinteDigital: [],
    listaArchivoExpedinteDigital: [],
    listaArchivoAntesGuardar: [],
    tipoHerramienta: null,
    archivoCarga: null,
    listaArchivosGuardar: [],
    loaderArchivo: false,
    listaExtensionesHerramienta: [],
    hoy: null,
    token: null,
    blnBtnHerramientas: true,
  }),
  props: {
    idPacienteArchivos: Number,
    carpetaPrincipal: Object ,
    carpetaArchivo: Object,
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();
    this.token = this.$localStorageService.getTokenAWS();
    await this.validarTokenAWS();
    this.obtenerFlujosExpediente();
    this.hoy = this.$moment().format("DD-MM-YYYY");
    this.blnBtnHerramientas = this.carpetaPrincipal.nombreRuta === "Radiografías y Fotografías";
  },
  methods: {
    async validarTokenAWS() {
      if (this.token !== null) {
        if (this.token.expireTo < moment(new Date()).format("YYYY-MM-DD HH:mm:ss")) {
          await this.awsServicio.obtenerTokenAcceso().then((response) => {
            this.token = response.data
            this.$localStorageService.setTokenAWS(this.token)
          })
        }else{
          if(typeof this.token === 'string'){
            this.token = JSON.parse(this.token);
          }
        }
      } else {
        await this.awsServicio.obtenerTokenAcceso().then((response) => {
          this.token = response.data
          this.$localStorageService.setTokenAWS(this.token)
        })
      }
    },
    mostrarSubirHerramientaModal() {
      this.showModalSubirHerramienta = !this.showModalSubirHerramienta;
    },
    obtenerFlujosExpediente() {
      this.$http.get(this.$api + 'catalogos/obtenerFlujoExpedinteDigital').then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.listaFlujoExpedinteDigital.push(it);
              })
            }
          }
      )
    },
    obtenerArchivoExpedientePorFlujo(e) {
      this.listaArchivoExpedinteDigital = [];
      this.$http.post(this.$api + 'herramientaExpedienteElectronico/obtenerHerramientasECEFlujo', e).then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.listaArchivoExpedinteDigital.push(it);
              })
            }
          }
      )
    },
    obtieneExtensionesArchivo(e) {
      this.tipoHerramienta = e;
      this.listaExtensionesHerramienta = [];
      e.extensiones.forEach(ext => {
        this.listaExtensionesHerramienta.push(ext.extension.toLowerCase());
      });
      setTimeout(() => {
        if (this.$refs['file-input-1']) {
          this.$refs['file-input-1'].reset();
        }
        if (this.$refs['file-input']) {
          this.$refs['file-input'].reset();
        }
      }, 1000);
    },
    async changeArchivoHerramienta(e) {
      let files = e.target.files || e.dataTransfer.files;

      for (let i = 0; i < files.length; i++) {
        const nombreArchivo = files[i].name;
        const nombreCortado = nombreArchivo.split('.');
        let extension = nombreCortado.pop().toLowerCase(); // Extrae la extensión

        let archivoAux = {
          nombreArchivo: nombreArchivo,
          estusCarga: this.listaExtensionesHerramienta.includes(extension),
        };

        this.listaArchivoAntesGuardar.push(archivoAux);


        if (archivoAux.estusCarga) {
          let timestamp = Date.now() + i; // Timestamp actual
          let nombreNuevo = `${this.idPacienteArchivos}_${this.tipoHerramienta.nombreHerramienta}_${timestamp}_${this.$localStorageService.getIdUsuario()}.${extension}`;

          this.listaArchivosGuardar.push({
            file: files[i],  // Guarda el objeto File original
            nombre: nombreNuevo,
            idHerramienta: this.tipoHerramienta.idHerramienta,
          });
        }
      }
    },
    cerrarModalHerramienta() {
      this.tipoHerramienta = null;
      this.showModalSubirHerramienta = false;
      this.showModalSubirHerramientaOrtodontica = false;
      this.listaArchivoAntesGuardar =[];
      this.listaArchivosGuardar = [];
    },
    async guardarHerramienta() {
      await this.validarTokenAWS();

      if (this.listaArchivosGuardar.length === 0) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Debes subir al menos un archivo de tipo " + this.listaExtensionesHerramienta.toString(),
        });
        this.cerrarModalHerramienta();
        return false;
      }

      this.loaderArchivo = true;

      let ruta = this.tipoHerramienta.rutaGuardarDigital.replace("#id_paciente", this.idPacienteArchivos.toString());
      let nombreCarpeta = `${this.tipoHerramienta.flujo.flujoExpedienteDigial} ${this.hoy}`;

      const prefixToRemove = "DOCSPRUEBA/";
      if (ruta.startsWith(prefixToRemove)) {
        ruta = ruta.substring(prefixToRemove.length);
      }

      let rutaDirectorio = `${ruta}/${nombreCarpeta}`;
      let archivosSubidos = [];

      let objetoEnviar = {
        idHerramienta: this.tipoHerramienta.idHerramienta,
        idPaciente: this.idPacienteArchivos,
        rutaDirectorio: rutaDirectorio,
        listaArchivos: this.listaArchivosGuardar,
      };

      const client = new S3Client({
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      });

      try {
        for (const [index, archivo] of this.listaArchivosGuardar.entries()) {
          try {
            let filePath = `${rutaDirectorio}/${archivo.nombre}`;
            const input = {
              Bucket: this.token.nombreBucket,
              Key: filePath,
              Body: archivo.file,
              ContentType: archivo.file.type,
            };

            const upload = new Upload({
              client: client,
              params: input,
              partSize: 5 * 1024 * 1024, // Multipart upload para archivos grandes
              queueSize: 4,
            });

            upload.on("httpUploadProgress", (progress) => {
              const porcentaje = Math.round((progress.loaded / progress.total) * 100);
              this.$set(this.listaArchivoAntesGuardar[index], "progreso", porcentaje);
            });

            await upload.done();
            archivosSubidos.push(filePath);
          } catch (error) {
            console.error(`Error al subir el archivo ${archivo.nombre}:`, error);
            throw error;
          }
        }

        const response = await this.$http.post(
            this.$api + "herramientaExpedienteElectronico/subirHerramienta",
            objetoEnviar
        );

        if (!response.data.success) {
          throw new Error("Error al guardar en la base de datos");
        }

        this.rutaOriginal = ruta;
        this.$emit("carpetaSeccionada", this.carpetaPrincipal);
        await new Promise(resolve => setTimeout(resolve, 500));
        this.$emit("carpetaSeccionadaArchivo", this.carpetaArchivo);


        this.$swal.fire({
          icon: "success",
          title: "Éxito",
          text: `Se subieron correctamente los archivos: ${archivosSubidos.map(a => a.split('/').pop()).join(", ")}`,
        });

      } catch (error) {
        console.error("Error en el proceso:", error);

        if (archivosSubidos.length > 0) {
          try {
            const deleteParams = {
              Bucket: this.token.nombreBucket,
              Delete: {
                Objects: archivosSubidos.map((filePath) => ({ Key: filePath })),
              },
            };
            const deleteCommand = new DeleteObjectsCommand(deleteParams);
            await client.send(deleteCommand);
            console.log("Archivos revertidos correctamente en S3.");
          } catch (deleteError) {
            console.error("Error al eliminar archivos de S3:", deleteError);
          }
        }

        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: `Hubo un problema: ${error.message}`,
        });

      } finally {
        this.loaderArchivo = false;
        this.archivoCarga = null;
        this.cerrarModalHerramienta();
        if (this.$refs['file-input']) {
          this.$refs['file-input'].reset();
        }
      }
    },
    change(e) {
      let file = e.target.files || e.dataTransfer.files;
      if (file[0].name.length >= 60) {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "El nombre del archivo es demasiado largo",
        });
      } else {
        this.nuevoArchivo(file);
      }
      e.target.value = "";
    },
    nuevoArchivo(file) {
      const nombreArchivo = file[0].name;
      const nombreCortado = nombreArchivo.split('.');
      let extension = nombreCortado.pop().toLowerCase();

      let archivoAux = {
        nombreArchivo: nombreArchivo,
        estusCarga: true,
      };

      this.listaArchivoAntesGuardar.push(archivoAux);

      let timestamp = Date.now(); // Timestamp actual
      let nombreNuevo = `${this.idPacienteArchivos}_HERRAMIENTA_ORTODONTICA_${timestamp}_${this.$localStorageService.getIdUsuario()}.${extension}`;

      this.listaArchivosGuardar.push({
        file: file[0],  // Guarda el objeto File original
        nombre: nombreNuevo,
        idHerramienta: null,
      });
    },
    async guardarHerramientaOrtodontica() {
      await this.validarTokenAWS();

      if (this.listaArchivosGuardar.length === 0) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Debes subir al menos un archivo de tipo " + this.listaExtensionesHerramienta.toString(),
        });
        this.cerrarModalHerramienta();
        return false;
      }

      this.loaderArchivo = true;
      let ruta = this.carpetaPrincipal.path.replace("#id_paciente", this.idPacienteArchivos.toString());
      let nombreCarpeta = `${this.hoy}`;

      const prefixToRemove = "DOCSPRUEBA/";
      if (ruta.startsWith(prefixToRemove)) {
        ruta = ruta.substring(prefixToRemove.length);
      }

      let rutaDirectorio = `${ruta}/${nombreCarpeta}`;
      let archivosSubidos = [];

      let objetoEnviar = {
        idHerramienta: null,
        idPaciente: this.idPacienteArchivos,
        rutaDirectorio: rutaDirectorio,
        listaArchivos: this.listaArchivosGuardar,
      };

      const client = new S3Client({
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      });

      try {
        for (const [index, archivo] of this.listaArchivosGuardar.entries()) {
          try {
            let filePath = `${rutaDirectorio}/${archivo.nombre}`;
            const input = {
              Bucket: this.token.nombreBucket,
              Key: filePath,
              Body: archivo.file,
              ContentType: archivo.file.type,
            };

            const upload = new Upload({
              client: client,
              params: input,
              partSize: 5 * 1024 * 1024, // Multipart upload para archivos grandes
              queueSize: 4,
            });

            upload.on("httpUploadProgress", (progress) => {
              const porcentaje = Math.round((progress.loaded / progress.total) * 100);
              this.$set(this.listaArchivoAntesGuardar[index], "progreso", porcentaje);
            });

            await upload.done();
            archivosSubidos.push(filePath);
          } catch (error) {
            console.error(`Error al subir el archivo ${archivo.nombre}:`, error);
            throw error;
          }
        }

        const response = await this.$http.post(
            this.$api + "herramientaExpedienteElectronico/subirHerramienta",
            objetoEnviar
        );

        if (!response.data.success) {
          throw new Error("Error al guardar en la base de datos");
        }

        this.rutaOriginal = ruta;
        this.$emit("carpetaSeccionada", this.carpetaPrincipal);
        await new Promise(resolve => setTimeout(resolve, 500));
        this.$emit("carpetaSeccionadaArchivo", this.carpetaArchivo);


        this.$swal.fire({
          icon: "success",
          title: "Éxito",
          text: `Se subieron correctamente los archivos: ${archivosSubidos.map(a => a.split('/').pop()).join(", ")}`,
        });

      } catch (error) {
        console.error("Error en el proceso:", error);

        if (archivosSubidos.length > 0) {
          try {
            const deleteParams = {
              Bucket: this.token.nombreBucket,
              Delete: {
                Objects: archivosSubidos.map((filePath) => ({ Key: filePath })),
              },
            };
            const deleteCommand = new DeleteObjectsCommand(deleteParams);
            await client.send(deleteCommand);
            console.log("Archivos revertidos correctamente en S3.");
          } catch (deleteError) {
            console.error("Error al eliminar archivos de S3:", deleteError);
          }
        }

        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: `Hubo un problema: ${error.message}`,
        });

      } finally {
        this.loaderArchivo = false;
        this.archivoCarga = null;
        this.cerrarModalHerramienta();
        if (this.$refs['file-input']) {
          this.$refs['file-input'].reset();
        }
      }
    }

  }
}
</script>

<style scoped>

</style>
